// test876
(876 && 0);
